import CustomerLink from "../shared/CustomerLink";

const STATUS_STYLES = {
  completed: "bg-[#27AE601A] text-[#219653]",
  pending: "bg-[#F2C94C33] text-[#B7791F]",
  failed: "bg-[#EB57571A] text-[#EB5757]",
  refunded: "bg-[#0000000D] text-[#4F4F4F]",
};

const isCrypto = (r) => r.type === "CRYPTO";

const usd = (n) =>
  `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const withdrawalColumns = ({ showCustomer = true } = {}) =>
  [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value) => (
        <p className="whitespace-nowrap">
          {new Date(value).toLocaleDateString()}{" "}
          <span className="text-[#00000080]">
            {new Date(value).toLocaleTimeString()}
          </span>
        </p>
      ),
    },
    showCustomer && {
      title: "Customer",
      key: "customer",
      render: (_, record) => (
        <div>
          <CustomerLink record={record} />
          <div className="text-[12px] text-[#00000080] lowercase">
            {record.customer?.email}
          </div>
        </div>
      ),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => (
        <p>{isCrypto(record) ? "Crypto send" : "Bank payout"}</p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (value, record) => {
        if (!isCrypto(record)) {
          return <p className="font-bold whitespace-nowrap">₦{Number(value || 0).toLocaleString()}</p>;
        }
        const dollars = record.usdAtTrade ?? record.usdNow;
        return (
          <p className="font-bold whitespace-nowrap">
            {`${Number(record.metadata?.coinQty ?? value)} ${String(record.coin || "").toUpperCase()}`}
            {dollars != null && (
              <span className="font-normal text-[#00000080]"> ({usd(dollars)})</span>
            )}
          </p>
        );
      },
    },
    {
      title: "Beneficiary",
      key: "beneficiary",
      render: (_, record) =>
        isCrypto(record) ? (
          <p className="text-[12px] break-all max-w-[220px]">{record.receiver}</p>
        ) : (
          <div>
            <p className="capitalize">{record.metadata?.beneficiary || "—"}</p>
            <div className="text-[12px] text-[#00000080]">
              {record.receiver}
            </div>
          </div>
        ),
    },
    {
      title: "Bank",
      key: "bank",
      render: (_, record) =>
        isCrypto(record) ? (
          <p className="text-[#00000080]">—</p>
        ) : (
          <p className="whitespace-nowrap">{record.bankName || "—"}</p>
        ),
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      render: (value) => <p className="text-[12px] break-all max-w-[180px]">{value}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => (
        <span
          className={`${STATUS_STYLES[value] || ""} rounded-[3px] px-[10px] py-[3px] text-[13px] capitalize`}
        >
          {value}
        </span>
      ),
    },
  ].filter(Boolean);
